module.exports = __webpack_public_path__ + "img/BETSY_VideoLoading_2.80ff4c73.png";